
export class Subarea {

    name: string = ''; // will be a whole number (not unique)

    ID: string = ''; // FA_ID used for input into DFO FOS

    // the array will only ever have more than 1 item if the subarea is a zone
    managementAreaNames: string[] = []; // management area(s) that the subarea belongs to

    zone: boolean = false; // tells us whether the subarea is a zone

    constructor(name: string = '', ID: string = '', 
    managementAreaNames: string[] = [], zone: boolean = false) {
        this.name = name;
        this.ID = ID;
        this.managementAreaNames = managementAreaNames;
        this.zone = zone;
    }

    // returns true if the subarea is valid (i.e. has a name and ID)
    public isValid(): boolean {
        return !!this.name || !!this.ID;
    }

    public toString(): string {

        if (!this.isValid()) { // if the subarea is invalid
            return ''; // return an empty string
        }
        if (this.zone) { // if the subarea is a zone
            return 'Zone ' + this.name; // just return the name
        }  
        // subarea formatting: 1-10 (1=management area name, 10=subarea name)
        return /*'Subarea ' + */ this.managementAreaNames[0] + '-' + this.name;
        
    }

    public static transformAnonArray(subareas: any): Subarea[] {

        // if list does not exist, set an empty array
       if (!subareas) {
        return [];
       }

        let tempArray: Subarea[] = [];
        for (let subarea of subareas) {
            tempArray.push(this.transformAnonymous(subarea));
        }
   
        return tempArray;

    }

    public static transformAnonymous(subarea: any): Subarea {

        if (!subarea) { // if the parameter is null
            return new Subarea(); // return an empty subarea
        }

        return new Subarea (
            subarea.name ?? '',
            subarea.ID ?? '',
            subarea.managementAreaNames ?? [],
            subarea.zone ?? false
        );

    }

}

